<template>
  <div>
    <div>
      <div class="inner-title">1. Rating by any Rating Agency?</div>
      <div class="table-wrapper-scroll-y my-custom-scrollbar">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th scope="col">Sl No</th>
              <th scope="col">Rating Agency</th>
              <th scope="col">Credit Rating</th>
              <th scope="col">Attachment</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(rating,index) in financialOther.ratings" :key="index">
              <td scope="col">{{index+1}}</td>
              <td scope="col">{{rating.ratingAgencyCode}}</td>
              <td scope="col">{{rating.agencyRating}}</td>
              <td scope="col">
                <a
                  @click="showFile(rating.ratingDocumentId)"
                  href="#"
                >{{getAttachmentName(rating.ratingDocumentId)}}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div>
      <div class="row mt-3">
        <div
          class="inner-title col-8"
        >2. Does your firm has possibility of merger or take-over by any of your competitors or new entrants or group companies?</div>
        <div class="col-2">
          <span v-if="financialOther.mergerPossibility=='Y'">Yes</span>
          <span v-else>No</span>
        </div>
        <div class="col-2">
          <span v-if="financialOther.mergerPossibility">{{financialOther.mergerDetails}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { PartnerService } from "../../services/partnerService";
const partnerService = new PartnerService();
export default {
  props: ["financialOther"],
  methods: {
    showFile(documentId) {
      this.loading = true;
      partnerService
        .downLoadDocument(documentId)
        .then(res => {
          this.loading = false;
          // alert("Downlodeded1");
        })
        .catch(e => {});
    },
    getAttachmentName(documentId) {
      let attachmentName = "";
      attachmentName = documentId.split(/_(.+)/)[1]
        ? documentId.split(/_(.+)/)[1]
        : documentId;
      return attachmentName;
    }
  }
};
</script>
<style scoped>
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  font-stretch: normal;
  line-height: 1.25;
  text-align: left;
  padding-bottom: 1%;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
}
.my-custom-scrollbar-business-vertical {
  /* position: relative; */
  max-height: 300px;
  width: 100%;
  overflow: auto;
}
</style>